(function () {
  function now() {
    var q = /[?&]hci_now=([^&]+)/.exec(location.search);
    return q ? new Date(decodeURIComponent(q[1])).getTime() : Date.now();
  }
  function on(el, t) {
    var s = el.dataset.start, e = el.dataset.end;
    return (!s || t >= Date.parse(s)) && (!e || t < Date.parse(e));
  }
  function run() {
    var t = now();
    document.querySelectorAll('[data-hci-group]').forEach(function (g) {
      var kids = [].slice.call(g.children).filter(function (k) { return k.hasAttribute('data-hci-state'); }), pick = null, def = null;
      kids.forEach(function (k) {
        if (!k.dataset.start && !k.dataset.end) { def = def || k; return; }
        if (!pick && on(k, t)) pick = k;
      });
      pick = pick || def;
      kids.forEach(function (k) { k.hidden = k !== pick; });
      g.hidden = !pick;
    });
    document.querySelectorAll('[data-hci-window]').forEach(function (w) { w.hidden = !on(w, t); });
  }
  run();
  setInterval(run, 60000);
})();
